module.exports = __webpack_public_path__ + "static/media/maintenance.26f2b774.png";